module.exports = __webpack_public_path__ + "static/images/jf-couponbg01.06b10fb.png";